// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ywqH","inner":"Footer_inner__3eUZ3","nextIcon":"Footer_nextIcon__13_jL","innerLeft":"Footer_innerLeft__3pD1H"};